window.FormaPagamento = Backbone.Model.extend({

});

window.FormasPagamento = Backbone.Collection.extend({
    model: FormaPagamento
});